export const childTypeList = [
  {
    name: "Форма навчання",
    childType1: "",
    childType2: "",
  },
  {
    name: "дошкільнятко",
    childType1: "дитини, яка відвідує дошкільний навчальний заклад",
    childType2: "дитині, яка відвідує дошкільний навчальний заклад",
  },
  {
    name: "учень",
    childType1: "дитини, яка відвідує загальноосвітній навчальний заклад",
    childType2: "учню",
  },
  {
    name: "студент",
    childType1: "студента навчального закладу I-IV рівнів акредитації",
    childType2: "студенту",
  },
];
export const maleNames = [
  "Аркадій",
  "Антон",
  "Артур",
  "Арсен",
  "Анатолій",
  "Семен",
  "Олег",
  "Василь",
  "Степан",
  "Михайло",
  "Мирон",
  "Мирослав",
  "Роман",
  "Тарас",
  "Святослав",
  "В'ячеслав",
  "Ярослав",
  "Володимир",
  "Петро",
  "Павло",
  "Гнат",
  "Борис",
  "Ростислав",
  "Станіслав",
  "Семен",
  "Тимур",
  "Лука",
  "Тимофій",
  "Тадей",
  "Пилип",
  "Адріан",
  "Андрій",
  "Валерій",
  "Едуард",
  "Віталій",
  "Віктор",
  "Григорій",
  "Максим",
  "Констянтин",
  "Ілля",
  "Любомир",
  "Руслан",
  "Рустам",
  "Назар",
  "Назарій",
  "Олексій",
  "Захар",
  "Олександр",
  "Іван",
  "Ігор",
  "Зіновій",
  "Артем",
  "Даніель",
  "Данило",
  "Артур",
  "Денис",
  "Владислав",
  "Вадим",
  "Юрій",
  "Владлен",
  "Матвій",
  "Устим",
  "Йосип",
  "Осип",
  "Орест",
  "Генадій",
  "Адам",
  "Кирило",
  "Гліб",
  "Богдан",
  "Євген",
  "Марк",
  "Марко",
  "Маркіян",
  "Адріян",
  "Олесь",
  "Сергій",
  "Альберт",
  "Валентин",
  "Влад",
  "Всеволод",
  "Георгій",
  "Гордій",
  "Дем'ян",
  "Давид",
  "Дмитро",
  "Єгор",
  "Зиновій",
  "Зорян",
  "Леонід",
  "Лев",
  "Мартин",
  "Мар'ян",
  "Нестор",
  "Омелян",
  "Остап",
  "Горден",
  "Северин",
  "Федір",
  "Юлій",
  "Юхим",
  "Юліан",
  "Ян",
  "Микола",
  // "",
];
